import React, { useState, useEffect } from "react";
import AdminSidebar from "../../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../../component/AdminComp/AdminTopbar";
import DataTable from "react-data-table-component"; // Import DataTable
import { Edit, Trash2 } from "react-feather";
import axios from "axios"; // Import axios for API calls
import { baseurl, imageUrl } from "../../../Baseurl"; // Assuming baseurl is defined
import Swal from "sweetalert2"; // Import SweetAlert2
import { Link } from "react-router-dom";
import { Spinner } from "react-bootstrap"; // Import Bootstrap Spinner

const AllHalfBanner = () => {
  const [banners, setBanners] = useState([]); // Manage banner state
  const [loading, setLoading] = useState(true); // Track API call status

  // Fetch banners from the API on component mount
  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await axios.get(`${baseurl}getAllBannersHalf`);
        setBanners(response.data.data); // Assuming the API returns an array of banners
      } catch (error) {
        console.error("Error fetching banners:", error);
      } finally {
        setLoading(false); // Hide loader after API call
      }
    };
    fetchBanners();
  }, []);

  // Delete banner with confirmation
  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This banner will be deleted permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.delete(`${baseurl}deleteBanner/${id}`);
          if (response.status === 200) {
            setBanners((prev) => prev.filter((banner) => banner.id !== id));
            Swal.fire("Deleted!", "Banner has been deleted.", "success");
          }
        } catch (error) {
          Swal.fire("Error!", "An error occurred while deleting the banner.", "error");
          console.error("Error deleting banner:", error);
        }
      }
    });
  };

  // Define columns for DataTable
  const columns = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: "Heading",
      selector: (row) => row.heading,
      sortable: true,
    },
    {
      name: "Banner Image",
      cell: (row) => <img src={`${imageUrl}banners/${row.banner_image}`} alt="banner" width={100} height={50} />,
    },
    {
      name: "Action URL",
      selector: (row) => row.action_url,
      sortable: true,
    },
    {
        name: "Status",
        selector: (row) => row.status,
        sortable: true,
        cell: (row) => (
          <span
            className={`badge ${row.status === "active" ? "bg-success" : "bg-danger"}`}
          >
            {row.status.charAt(0).toUpperCase() + row.status.slice(1)} 
          </span>
        ),
      },
      
    {
      name: "Actions",
      cell: (row) => (
        <div>
          <Link to={`/admin/edit-banner/${row.id}`}
            className="btn btnedit me-2"
          >
            <Edit size={16} />
          </Link>
          <button
            className="btn btndelete"
            onClick={() => handleDelete(row.id)}
          >
            <Trash2 size={16} />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />

      {/* Content area */}
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4 className="text-start">Half Banners</h4>
            <Link to="/admin/banner-half"
              className="addbtn" 
            >
              Add Half Banner
            </Link>
          </div>


          <div className="text-start mb-2">
                      <Link to="/admin/full-banner" className="nacs me-2">Full Banner</Link> 
                      <Link to="/admin/half-banner" className="nacs me-2">Half Banner</Link> 
                      <Link to="/admin/new-banner" className="nacs me-2">Other Banner</Link> 
                    </div>
 


          {/* Show loader while fetching data */}
          {loading ? (
            <div className="text-center my-5">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          ) : (
            /* React DataTable */
            <div className="table-responsive">
              <DataTable
                columns={columns}
                data={banners}
                pagination
                highlightOnHover
                responsive
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AllHalfBanner;
